import { render, staticRenderFns } from "./tanuki_ai_icon.vue?vue&type=template&id=4b30f2a7"
import script from "./tanuki_ai_icon.vue?vue&type=script&lang=js"
export * from "./tanuki_ai_icon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports